module.exports = __webpack_public_path__ + "img/ywjz2.2eaaa8e5.png";